<template>
    <div class="history">
        <h1 class="title-page">
            <b> {{ getTranslatedText(`history`) }}</b>
        </h1>
        <HistorySearch @search="handleSearch" />
        <template v-if="!$store.state.isLogin">
            <div class="row">
                <h3 class="text-center mt-3">
                    {{ getTranslatedText(`please login`) }}
                </h3>
            </div>
        </template>
        <template v-else>
            <HistoryDetail :history-data="historyData" :is-loading="isLoading" :current-page="currentPage"
                :total-pages="totalPages" @change-page="handlePageChange" />
        </template>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import utilMixins from "@/mixins/utils/utils-mixins";
import HistorySearch from "./components/HistorySearch.vue";
import HistoryDetail from "./components/HistoryDetail.vue";
import historyService from "@/services/history/index.service";

export default {
    components: { HistorySearch, HistoryDetail },
    mixins: [languageMixins, utilMixins],
    data() {
        return {
            currentPage: 1,
            isLoading: false,
            totalPages: 1,
            historyData: []
        }
    },
    watch: {
        '$store.state.settings.currentGame': {
            handler(newGame) {
                if (newGame) {
                    this.handlePageChange(1);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleSearch(searchParams) {
            this.currentPage = 1;
            const payload = {};

            if (searchParams.transactionId) {
                payload.transactionId = searchParams.transactionId;
            }

            if (searchParams.fromDate) {
                payload.from_date = this.getFullDateYMD(this.getCurrentDateTime(searchParams.fromDate));
            }

            if (searchParams.toDate) {
                payload.to_date = this.getFullDateYMD(this.getCurrentDateTime(searchParams.toDate));
            }

            this.fetchData(payload);
        },

        getCurrentDateTime(date) {
            let currentDate = new Date(date)
            currentDate.setHours(new Date().getHours())
            currentDate.setMinutes(new Date().getMinutes())
            return currentDate;
        },

        async fetchData(searchParams = {}) {
            this.isLoading = true;
            let payload = {
                limit: 10,
                current_page: this.currentPage,
                ...searchParams
            }

            try {
                const response = await historyService.getHistory(payload);
                this.historyData = response.data;
                this.totalPages = response.paginator?.total_pages || 1;
            } catch (error) {
                console.error('Error fetching history data:', error);
            } finally {
                this.isLoading = false;
            }
        },

        handlePageChange(page) {
            this.currentPage = page;
            this.fetchData();
        },
    }
}
</script>

<style lang="scss">
@import "@/public/scss/history.scss";
</style>